import React from "react";

export const teatrinoTitle = (
  <div>
    Programa de <i>El pleito del queso</i>
  </div>
);

export const teatrinoContent = (
  <div>
    <p className="content justified">
      El teatro fue, quizá, una de las formas de escritura más naturales para Oswaldo Díaz Díaz. “...su fervorosa
      inteligencia ha encontrado en el teatro su más afortunada forma de expresión. Trabaja en él con pasión y con
      admirable seguridad. Maneja diestramente la técnica dramática”. <em>Revista de las Indias</em>, 1941.
    </p>
    <p className="content justified">
      En 1941 Oswaldo Díaz Díaz terminó de escribir <em>Blondinette</em>, obra teatral que fue estrenada el 17 agosto
      del mismo año en la Radiodifusora Nacional de Colombia. En la noche del estreno, Don Os hizo el papel de Blondel,
      un payaso de corazón musical. Esta obra de teatro se ha considerado como la predilecta de Díaz Díaz.
    </p>
    <p className="content justified">
      Díaz Díaz vio realizada su iniciativa de recopilar todas sus obras de teatro para hacerlas perdurar en el tiempo y
      ponerlas a disposición de bibliotecas y amigos, sin fines comerciales, ya que de 1937 a 1961 compiló sus textos en
      cuatro volúmenes titulados <em>Teatro</em>.
    </p>
  </div>
);
